














































































































/**
 * @file FormField.vue のスタイルのみのコンポーネント
 */
import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    tag: {
      type: String as PropType<'label' | 'div'>,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelId: {
      type: String,
      default: '',
    },
    inputCounter: {
      type: String,
      default: null,
    },
    subLabel: {
      type: String,
      default: null,
    },
    tinyLabel: {
      type: Boolean,
      default: false,
    },
    tightLabel: {
      type: Boolean,
      default: false,
    },
    tightSubLabel: {
      type: Boolean,
      default: false,
    },
    largeLabel: {
      type: Boolean,
      default: false,
    },
    verticalLabel: {
      type: Boolean,
      default: false,
    },
    boldLabel: {
      type: Boolean,
      default: false,
    },
    bigSubLabel: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object as PropType<Record<string, string[]>>,
      default: () => ({}),
    },
    manualErrors: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    note: {
      type: String,
      default: null,
    },
    noteRight: {
      type: Boolean,
      default: false,
    },
    noteMultipleLines: {
      type: Boolean,
      default: false,
    },
    tightHeight: {
      type: Boolean,
      default: false,
    },
    flexGap: {
      type: String,
      default: '',
    },
    gridCols: {
      type: String,
      default: '',
    },
  },
  setup(props, { slots }) {
    const isSingleSlot = computed(() => {
      return slots.default?.({}).length === 1;
    });

    return {
      isSingleSlot,
    };
  },
});
